import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-words-stats.scss";
import {IWebsiteBlackWordsStats} from "./types/IWebsiteBlackWordsStats";
import {WebsiteBlackUnionLineComponent} from "../../union/line/WebsiteBlackUnionLineComponent";

export class WebsiteBlackWordsStatsComponent extends Component {
    constructor(p: IWebsiteBlackWordsStats) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackWordsStats}">
                <div class="${s.union}">
                    ${this.draw(new WebsiteBlackUnionLineComponent(p.color))}
                </div>
                <div class="${s.explore}">
                    ${p.description}
                </div>
                <div class="${s.charts}">
                    ${p.entries.map(value => `
                    <div class="${s.entry}">
                        <div class="${s.title}">
                            ${value.title}
                        </div>
                        <div class="${s.chart} ${value.color ? s[value.color] : ``}">
                            <div class="${s.bar}">
                                <div style="width: ${value.width};" class="${s.progression}"></div>
                            </div>
                            <div class="${s.value}">
                                ${value.value}
                            </div>
                        </div>
                    </div>
                    `).join("")}
                </div>
            </div>
        `;
    }

    commit() {
        this.els(s.progression).forEach(progressionComponent => {
            let width = parseInt(progressionComponent.getHTMLElement().style.width);

            this.el(s.charts).isBelowScroll((isVisible) => {
                if (isVisible) {
                    progressionComponent.translate({widthPercent: width, delay: 600});
                } else {
                    progressionComponent.translate({widthPercent: 0, delay: 600});
                }
            }, true);
        })

        super.commit();
    }

}